import { render, staticRenderFns } from "./LeaveAdminView.vue?vue&type=template&id=776e67f7"
import script from "./LeaveAdminView.ts?vue&type=script&lang=ts&external"
export * from "./LeaveAdminView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports